import AmpDashborad from './layouts/amp';
import { useSelector } from 'react-redux';
import TIFDashboard from './layouts/tif';
import { tifRoles } from '../../../../../constants/user';

export default function Dashboard() {
  const { user } = useSelector((state) => state.authentication);

  if (user?.appRole?.code === tifRoles.AMP) {
    return <AmpDashborad />
  }

  return <TIFDashboard />
}
